<template>
  <v-dialog v-model="editDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <template v-slot:activator="{ on, attrs }">      
      <v-btn class="mx-2 d-none d-md-inline-flex" v-bind="attrs" v-on="on" @click="openAction" style="margin-top: 8px;">
        Imprimir
        <v-icon right dark>mdi-printer</v-icon>
      </v-btn>
    </template>

    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <div v-if="loading || !pdfSource">
      <v-skeleton-loader
        class="mx-auto d-none d-md-block"
        type="article, actions"
      ></v-skeleton-loader>

      <v-skeleton-loader
        class="mx-auto d-md-none"
        type="list-item-avatar, list-item-three-line, table-tfoot, list-item-two-line, article, table-heading, list-item-three-line, actions"
      ></v-skeleton-loader>
    </div>

    <v-card v-else>
      <v-card-title class="px-3 py-0 px-md-5 py-md-1">
        <span class="text-subtitle-2 text-sm-subtitle-1 text-md-h6 text-lg-h5 font-weight-bold">{{ pdfTitle }}</span>
        <v-spacer></v-spacer>
        <v-btn text icon title="Cancelar" class="my-2" @click="cancelAction">
          <v-icon right>mdi-close-circle</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="mt-5 px-3 px-sm-4 px-md-6">

        <pdf v-for="i in pdfNumPages" :key="i" :page="i" :src="pdfSource"></pdf>

        <slot name="editForm"></slot>

      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="px-2 py-0 px-md-4 py-md-1">
        <v-btn class="my-2" @click="cancelAction">
          {{ editCancelButtonLabel }}
        </v-btn>

        <v-spacer></v-spacer>
        <v-tooltip top>
          <template v-slot:activator="{ on: tooltipDownload }">
            <a style="text-decoration: none;" :href="pdfSource" :download="pdfTitle + '.pdf'">
              <v-btn v-on="{ ...tooltipDownload }">
                Download
                <v-icon small class="mr-2" right>
                  mdi-download
                </v-icon>
              </v-btn>
            </a>
          </template>
          <span>{{ 'Download do arquivo ' + pdfTitle + '.pdf' }}</span>
        </v-tooltip>
      </v-card-actions>
    </v-card>


  </v-dialog>


  <!-- <div>
    <v-btn class="mx-2 d-none d-md-inline-flex" 
      @click="print"
      :disabled="disabledPrint"
      v-if="!printing"
    >
      {{printButtonLabel}}
      <v-icon right dark>mdi-printer</v-icon>
    </v-btn>

  </div> -->
</template>

<script>
// import jsPDF from 'jspdf' 
// import html2canvas from "html2canvas"
// import moment from "moment";

import pdf from 'vue-pdf'

export default {
  data: function () {
    return {
      printing: false,
      loggedUser: {},
      editDialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      pdfSource: null,
      pdfNumPages: null,  
      loading: true,    
    }
  },
  props: {
    bottomMargin: {
      default: "10px",
      type: String,
    },
    // pdfSource: {
    //   type: String
    // },
    // pdfNumPages: {
    //   default: 1,
    // },
    editCancelButtonLabel: {
      type: String,
      default: "Cancelar"
    },
    printButtonLabel: {
      type: String,
      default: "Imprimir"
    },
    printableElementId: {
      type: String,
      require: true
    },
    printTitle: {
      type: String,
      default: "Relatório AgroSim"
    },
    disabledPrint: {
      type: Boolean,
      default: false
    },
    // loading: {
    //   type: Boolean,
    //   default: false
    // },
    pdfTitle: {
      type: String,
      default: "Relatório de disponibilidade de produção"
    },
  },
  components: {
    pdf: pdf,
  },
  created() {
    this.getCurrentUser(user => {
      this.loggedUser = user;
    });
  },
  methods: {
    cancelAction: function () {
      this.editDialog = false
      this.$emit("edit-cancel-action")
    },
    confirmAction: function () {
      this.$emit("edit-confirm-action")
    },
    openAction: function () {
      // var obj={pdf: null, numPages: 0};
      this.loading=true;
      var self = this;
      this.$emit("pdf-open-action", (obj)=>{
        // console.log('obj', obj);
        this.pdfSource = obj.pdf;
        // console.log(this.pdfSource);
        this.pdfNumPages = obj.numPages; 
        this.loading=false;
        if(obj.pdf){
          //ok
        }else{
          //show error message !!!
          self.loading=false;
          self.closeDialog();
          // self.$refs.baseIndex.showErrorMessage("Erro ao gerar o relatório. Tente novamente mais tarde ou contate o suporte.");
        }
      });
    },
    closeDialog: function () {
      this.editDialog = false;
    },
  }
}
</script>

<style scoped></style>
